// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"styles_deleteButton__hIRkE","colorPicker":"styles_colorPicker__jhGTu","fadeInOut":"styles_fadeInOut__rHiCK","loader":"styles_loader__GG_8n"};